export default __webpack_public_path__ + "static/media/python.effce043.jpg";